import axios, { AxiosRequestConfig } from "axios";
import PageRoutes, { APIRoutes } from "../utils/constants";
import { refreshAccessToken } from "../utils/authRefreshInterceptor";
import ConfigData from "../Config/config.json";
import { clearGaUserId } from "../utils/gaUser";
const data: any = ConfigData;
const website: any = process.env.REACT_APP_ENV;
const api_url = data[website]?.api_url;
export type authDetailsType = {
  AccessToken: string;
  RefreshToken: string;
  LiniusAccessToken?: string;
  LiniusRefreshToken?: string;
  UserID: string | number;

  FirstName: string;
  LastName: string;

  Email: string;
};

export const getCurrentAuth = () => {
  const localAuth = localStorage.getItem("auth");

  const auth: authDetailsType = localAuth
    ? JSON.parse(localStorage.getItem("auth") || "")
    : {};
  return auth;
};

export const Logout = () => {
  const auth = getCurrentAuth();
  // Clear local state synchronously so callers can `Logout(); navigate()` safely.
  localStorage.removeItem("auth");
  localStorage.clear();
  // HTPTV-682: drop the GA4 user_id so a shared browser doesn't carry it over.
  clearGaUserId();
  // Best-effort server-side revocation (deletes the RT from Redis). Bare axios
  // bypasses the response interceptor so a 401 here doesn't trigger a refresh loop.
  if (auth?.AccessToken) {
    axios
      .post(
        `${api_url}${APIRoutes.Logout}`,
        {},
        {
          headers: { Authorization: `bearer ${auth.AccessToken}` },
          timeout: 3000,
        }
      )
      .catch(() => {});
  }
};
const axiosInstance = axios.create();
/*
 * The refresh every client in this app shares.
 *
 * This file used to run its own, with its own de-duplication, and that is
 * what produced two /refreshToken calls for one expiry: a 200 followed by a
 * 400. The server keeps a single refresh token per user and replaces it on
 * every refresh, so the second request, still holding the token the first one
 * had just rotated away, is rejected and the session ends.
 *
 * Its guard could not prevent that. `flag` was cleared again the moment a
 * refresh succeeded, by every request waiting on it, which re-opened the gate
 * before the retries had gone out. And `refresh` read the stored token, then
 * awaited an IP lookup over the network, and only then posted, so the value it
 * sent could be several hundred milliseconds stale by the time it arrived.
 *
 * The shared promise has neither problem: it is cleared only when the request
 * it stands for has finished, and it reads the token immediately before
 * sending it.
 *
 * ip_address goes no more. The route neither requires nor validates it, and
 * the address it carried was fetched from a third party on the critical path
 * of every session renewal.
 */
function shouldRetry(config: any) {
  return config.retries.count < 3;
}

axiosInstance.interceptors.request.use(
  // @ts-ignore: Unreachable code error
  (config: AxiosRequestConfig) => {
    const auth = getCurrentAuth();
    if (!config.headers!["Authorization"]) {
      if (config.url?.includes("linius")) {
        config.headers!["LiniusAccessToken"] = auth?.LiniusAccessToken;
        config.headers!["LiniusRefreshToken"] = auth?.LiniusRefreshToken;
      }
      config.headers!["Authorization"] = `bearer ${auth?.AccessToken}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    error.config.retries = error.config.retries || {
      count: 0,
    };
    const originalRequest = error.config;

    // logout user's session if refresh token api responds 401 UNAUTHORIZED

    // if request fails with 401 UNAUTHORIZED status and 'Token has expired' as response message
    // then it calls the api to generate new access token
    if (error.response.status === 401 && shouldRetry(error.config)) {
      error.config.retries.count += 1;
      const updatedToken = await refreshAccessToken(api_url);
      if (!updatedToken) {
        Logout();
        window.location.href = `${PageRoutes.Login}?user=true`;
      } else {
        originalRequest.headers["Authorization"] = `bearer ${updatedToken}`;
        return axiosInstance(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
